import { useTranslation } from "react-i18next";
import type { IDuplicateModalProps } from "@app/dashboard/types/innerLayout/iframes/duplicate-iframe";
import type { IButton } from "libs/design-system/src/types/Button/button";
import type { IModalSharedProps } from "libs/design-system/src/types/modal";
import { Check, Xmark } from "libs/design-system/src/assets/Icons";
import { Modal, StatusIndicator } from "@unified-checkout/design-system";
import { IframeModal } from "..";


export const DuplicateModal = ({
  open,
  isLoading,
  isError,
  isSuccess,
  iframeForm,
  onClose,
  onConfirm,
  onFormChange,
}: IDuplicateModalProps) => {
  const { t } = useTranslation();

  const isProcessDone = isError || isSuccess;

  const title = isProcessDone ?
    ''
    :
    t(`innerLayout.iFramesPage.duplicateModal.title`);

  const btns = isProcessDone ?
    []
    :
    [
      {
        size: "md",
        color: "primary",
        variant: "contained",
        text: t(`innerLayout.iFramesPage.addModal.submitForm`),
        onClickHandler: onConfirm,
        loading: isLoading,
        disabled: isLoading,
      } as IButton,
      {
        size: "md",
        color: "secondary",
        variant: "outlined",
        text: t("innerLayout.iFramesPage.deleteModal.cancelButton"),
        onClickHandler: onClose,
      } as IButton,
    ]
  const hintText = isError ?
    t("innerLayout.errors.smthWentWrong")
    :
    t("innerLayout.iFramesPage.addModal.successMessage")

  const modalProps: IModalSharedProps = {
    state: "default",
    open,
    onCloseHandler: onClose,
    hasCloseIcon: true,
    title,
    position: "center",
    btnsProps: btns
  }

  const status = isProcessDone ?
    (
      <StatusIndicator
        status={isError ? "error" : "success"}
        icon={isError ? Xmark : Check}
        hintText={hintText}
      />
    )
    :
    <IframeModal form={iframeForm} setForm={onFormChange} />;

  return (
    <Modal {...modalProps}>
      {status}
    </Modal>
  );
};
